import { useMemo } from 'react'

import withSentryWrapper from 'src/components/common/withSentryWrapper'

const Button = ({
    disabled = false,
    onClick = () => {},
    intent = '',
    size = '',
    label = '',
    customClass = null,
    extendClass = null,
    children,
}) => {
    // TODO change focus:outline-none to primary color after confirmation
    const className = useMemo(() => {
        let baseClassNames = 'rounded-sm'

        switch (intent) {
            case 'primary': // red
                baseClassNames += ' bg-primary-red-500 text-white '
                break
            case 'info': // white
                baseClassNames += ' bg-white text-black '
                break
            case 'secondary': // white
                baseClassNames +=
                    ' bg-transparent text-primary-red-500 border border-primary-red-500'
                break
            default:
                baseClassNames +=
                    ' bg-transparent text-white border border-neutral-gray-400'
                break
        }

        switch (size) {
            case 'large': // red
                baseClassNames +=
                    ' px-4 py-2 2xl:px-6 2xl:py-2 text-sm 2xl:text-base  '
                break
            case 'small': // white
                baseClassNames += '  px-2 py-2  text-xs  '
                break
            default:
                baseClassNames +=
                    '  px-3 py-2 2xl:px-4 2xl:py-2 text-xs 2xl:text-sm '
                break
        }

        if (customClass) {
            baseClassNames = customClass
        }

        if (disabled) {
            baseClassNames += ' cursor-not-allowed opacity-05 '
        }

        if (extendClass) {
            baseClassNames = extendClass + ' ' + baseClassNames
        }

        return baseClassNames
    }, [customClass, disabled, extendClass, intent, size])

    return (
        <>
            <button className={className} onClick={onClick} disabled={disabled}>
                {children || label}
            </button>
        </>
    )
}

export default withSentryWrapper(Button)
